var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"el-fade-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"card raised",class:[
      _vm.cardTypeClassname,
      {
        'card--bordered': _vm.bordered,
        'card--hide-overflow': _vm.hideOverflow,
        'card--no-padding': _vm.noPadding,
        'card--scrollable': _vm.scrollable,
        'card--no-margin': _vm.noMargin,
      },
    ]},[(!_vm.isLoading)?_c('div',{staticClass:"card__block"},[_vm._t("default")],2):_c('div',{staticClass:"card__block card__block--loading"},[_c('HollowDotsSpinner',{attrs:{"animation-duration":1000,"dot-size":12,"dots-num":3,"color":'#95a5a6'}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }